import CloseSvg from 'assets/filters/close.svg';
import Search from 'assets/filters/searchIcon.svg';
import Input from 'common-ui/input';
import { CloseIcon } from 'common-ui/modal/Modal.styles';

import { ClearAllColumn, ClearAllRow, ClearAllText, InputWrapper } from './ByUser.styles';

export const Filter = () => {
  return (
    <InputWrapper>
      <Input label="First name" leftIcon={Search} />
      <Input label="Last name" leftIcon={Search} />
      <Input label="E-mail" leftIcon={Search} />
      <ClearAllRow>
        <ClearAllColumn>
          <CloseIcon src={CloseSvg} alt="close" />
          <ClearAllText>Clear all</ClearAllText>
        </ClearAllColumn>
      </ClearAllRow>
    </InputWrapper>
  );
};
